export default __webpack_public_path__ + "static/media/Facebook_Logo.2d63e245.svg";